import { Box, Button, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import api, { ProductDto, ProductUpdateDto, RetailerProductDto, VendorDto } from "../../../api";
import { DefaultMessageDialogOptions, MessageDialog, MessageDialogButton, MessageDialogButtons, MessageDialogIcon, MessageDialogOptions, notif } from "../../utils";
import { ProductDialog } from "./ProductDialog";
import { ProductsGrid } from "./ProductsGrid";

export interface ProductsTabPageProps {
  vendor?: VendorDto | null;
}

type MessageOrigin = "delete";

export const ProductsTabPage = (props: ProductsTabPageProps) => {
  const { vendor } = props;

  const [selected, setSelected] = useState<ProductDto[]>([]);
  const [edit, setEdit] = useState<Partial<ProductUpdateDto> | null>(null);
  const [message, setMessage] = useState<MessageDialogOptions<MessageOrigin>>(DefaultMessageDialogOptions<MessageOrigin>());

  const onRowsSelected = (rows: ProductDto[]) => {    
    setSelected(rows);
  };
  const onEdit = () => {
    if (selected?.length === 1) {
      setEdit({
        id: selected[0].id,
        sku: selected[0].sku,
        quantity: selected[0].quantity,
        isDiscontinued: selected[0].isDiscontinued,
        tokens: selected[0].tokens ?? [],
      });
    }
  };
  const onDelete = () => {
    if (selected?.length > 0) {
      setMessage({
        open: true,
        title: "DELETE PRODUCT",
        buttons: MessageDialogButtons.YesNo,
        icon: MessageDialogIcon.Question,
        content: selected.length === 1 ? `Do you want to delete product '${selected[0].sku}'?` : `Do you want to delete '${selected.length}' selected products?`,
        checks: [{ label: "Delete all dependent entities", value: false }],
        origin: "delete",
      });
    }
  };
  const deleteProduct = async (cascade?: boolean) => {
    if (selected?.length > 0) {
      try {
        const ids = selected.map(p => p.id!);
        await api.product.delete({ ids, cascade } as any);
      } catch (err) {
        notif(err, "error");
      }
    }
  };
  const onMessageSubmit = async (button: MessageDialogButton, origin?: MessageOrigin, checks?: boolean[]) => {
    setMessage({ open: false });
    if (origin === "delete" && button === MessageDialogButton.Yes) {
      await deleteProduct(checks ? checks[0] : false);
    }
  };
  const onProductDialogSubmit = (dto: RetailerProductDto | null) => {
    setEdit(null);
    // if (dto !== null) setSelected(dto);
    setSelected([]);
  };

  useEffect(() => {

  }, [selected]);

  return (
    <Box>
      <ProductsGrid vendorId={vendor?.id || ""} onRowsSelected={onRowsSelected} />
      <Box sx={{ p: 1 }} />
      <Stack spacing={2} direction="row">
      <Button variant="contained" disabled={selected.length !== 1} onClick={onEdit}>
          Edit
        </Button>
        <Button variant="contained" disabled={selected?.length < 1} onClick={onDelete}>
          Delete
        </Button>
      </Stack>
      <ProductDialog product={edit} onSubmit={onProductDialogSubmit} />
      <MessageDialog options={message} onSubmit={onMessageSubmit} />
    </Box>
  );
};
